import { useState } from 'react'
import { useMutation } from '@apollo/client'

import ConfirmCopyPublishedTemplatesModal from './ConfirmCopyPublishedTemplatesModal'
import useModal from '../../../../lib/hooks/useModal'
import useNotification from '../../../../lib/hooks/useNotification'
import { COPY_ALL_PUBLISHED_TEMPLATES_MUTATION } from '../../../../graphql/plans'
import { CopyAllPublishedTemplatesMutation } from '../../../../generated/graphql'

type ConfirmCopyPublishedTemplatesModalWrapperProps = {
  /** Determines visibility of modal */
  isOpen: boolean
}

const ConfirmCopyPublishedTemplatesModalWrapper = ({
  isOpen
}: ConfirmCopyPublishedTemplatesModalWrapperProps) => {
  const { hideModal } = useModal()
  const { showSuccessNotif, showErrorNotif } = useNotification()
  const [isLoading, setIsLoading] = useState(false)

  const [copyAllPublishedTemplates] = useMutation<CopyAllPublishedTemplatesMutation>(
    COPY_ALL_PUBLISHED_TEMPLATES_MUTATION,
    {
      onCompleted: (data) => {
        setIsLoading(false)
        hideModal()
        const { copiedCount, success, message } = data.copyAllPublishedTemplates
        if (success) {
          showSuccessNotif(message || `Successfully copied ${copiedCount} published templates`)
        } else {
          showErrorNotif(message || 'Failed to copy published templates', copyAllPublishedTemplates)
        }
      },
      onError: (error) => {
        setIsLoading(false)
        hideModal()
        showErrorNotif(
          `Error copying published templates: ${error.message}`,
          copyAllPublishedTemplates
        )
      }
    }
  )

  const onConfirm = () => {
    setIsLoading(true)
    copyAllPublishedTemplates()
  }

  return <ConfirmCopyPublishedTemplatesModal isOpen={isOpen && !isLoading} onConfirm={onConfirm} />
}

export default ConfirmCopyPublishedTemplatesModalWrapper
